import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e76055"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-container"
}
const _hoisted_2 = {
  key: 1,
  class: "footer xag-page__footer nongfu-button-wrap"
}
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = { class: "order-price" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单金额：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "￥", -1))
const _hoisted_7 = { class: "price-value" }

import { Button, Dialog } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { getThousandMoney } from '@/utils/index'
import { getWuyouBuyDetail, confirmPayWuyouOrder, checkWuyouPayOrderStatus } from '@/apis/insurance'
import { ref, Ref, onUnmounted } from 'vue'
import { ConfirmUseStorageData } from '@/types/invoice'
import { DevicePayInfoType, WuyouPayOrderDetail, ConfirmWuyouBuyPrams } from '@/types/insurance'
import {
  showToastLoading,
  clearToast,
  showConfirmModal,
  showToastSuccess,
  showToastFail,
  showNormalToast,
} from '@/utils/tools'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import DevicePayInfo from '../components/device-pay-info.vue'
import OrderApply from '@/components/invoice/order-apply.vue'
import wx from 'weixin-js-sdk'
import wxHost from '@/utils/wx'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-order',
  setup(__props) {

const detail: Ref<DevicePayInfoType | null> = ref(null)
const $route = useRoute()
const sequence = $route.query.sequence as string
const version = $route.query.version as string

onUnmounted(() => {
  clearInterval(timeId)
  clearToast()
})
const cacheKey = 'InsuranceWuyouPayOrderDetail' + sequence
const cacheString = sessionStorage.getItem(cacheKey)
let invoiceInfo: ConfirmUseStorageData | null = null
let cacheData: WuyouPayOrderDetail | null = null
try {
  cacheData = cacheString ? JSON.parse(cacheString) : null
} catch (error) {}
let timeId: number
function paySuccessHandle() {
  if (wxHost.isMiniprogram) {
    // 小程序的时候
    wx.miniProgram.reLaunch({
      url: '/pages/entry',
    })
  }
}
function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkWuyouPayOrderStatus(pay_order_no)
      .then((result) => {
        if (result.is_pay) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          setTimeout(() => {
            // 检测支付成功后直接跳转小程序首页
            paySuccessHandle()
          }, 2000)
        }
      })
      .catch((error) => {
        console.log('error', error)
        clearInterval(timeId)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
function invoiceInit(data: ConfirmUseStorageData) {
  invoiceInfo = data
}
async function confirmPay() {
  console.log('invoiceInfo', invoiceInfo)
  if (!invoiceInfo || !invoiceInfo.needInvoice) {
    // 必须选择发票
    showNormalToast('请先选择发票抬头！')
    return
  }
  try {
    await showConfirmModal({
      message: '是否确认支付订单?',
      className: 'repair-dialog',
    })
    const parameter: ConfirmWuyouBuyPrams = {
      sn: sequence,
      version,
    }
    if (invoiceInfo && invoiceInfo.needInvoice) {
      parameter.invoice_guid = invoiceInfo.invoice.guid
      parameter.invoice_type = '1'
    }
    showToastLoading()
    const result = await confirmPayWuyouOrder(parameter)
    clearToast()

    const payOrderNo = result
    appHost.onPay(payOrderNo) // 调用app支付
    clearToast()
    handleSearchOrderPayStatus(payOrderNo)
    console.log('result', result)
  } catch (error) {
    showToastFail(error?.message || (error ? '支付失败' : '取消支付'))
    console.log('error', error)
  }
}
async function initPageDetail() {
  showToastLoading()
  try {
    const data = cacheData
      ? cacheData
      : await getWuyouBuyDetail({
          serial_number: sequence,
          version,
        })
    sessionStorage.setItem(cacheKey, JSON.stringify(data))
    detail.value = {
      deviceCommonInfo: {
        img: data.logo,
        name: data.equipment_name,
        sequence,
      },
      serviceInfoList: [
        {
          label: '设备型号',
          value: data.equipment_model,
        },
        {
          label: '无忧计划',
          value: data.safeguard_time,
        },
        {
          label: '服务说明',
          value: data.definition_description,
        },
      ],
      buyInfo: {
        title: data.definition_name + '服务费',
        price: getThousandMoney(Number(data.price)),
      },
    }
    clearToast()
  } catch (error) {
    console.log('error', error)
    showToastFail(error?.message || (error ? '支付失败' : '取消支付'))
  }
}
initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "订单确认和支付" }),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DevicePayInfo, { detail: detail.value }, null, 8, ["detail"]),
          _createVNode(OrderApply, { onInvoiceInit: invoiceInit })
        ]))
      : _createCommentVNode("", true),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(detail.value.buyInfo.price), 1)
            ]),
            _createVNode(_unref(Button), {
              class: "xa-vant-button",
              onClick: confirmPay,
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("支付订单")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})